<template>
  <div>
    <PageContainer>
      <DatePicker class="mt-4" v-model="dateKey"/>
      <div class="order mt-8" v-for="order in orders" :key="order.order.id">
        <OrderHeader
          :order="order.order"
          :total-price="order.orderItems.reduce((p, it) => p + it.subtotal_sales_price_without_tax , 0)"
        />
        <OrderTable :items="order.orderItems" />
      </div>
    </PageContainer>
  </div>
</template>

<script>
import PageContainer from "@/components/shop/PageContainer.vue";
import OrderHeader from "@/components/shop/orders/OrderHeader.vue";
import OrderTable from "@/components/shop/orders/OrderTable.vue";
import DatePicker, { nextDateKey } from "@/components/shop/DatePicker.vue";

export default {
  components: {
    PageContainer,
    OrderHeader,
    OrderTable,
    DatePicker
  },

  data() {
    return {
      dateKey: this.$route.query.date || nextDateKey(),
      orders: []
    };
  },

  watch: {
    dateKey() {
      this.loadData();
    }
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const { result } = await this.$http(
        "get",
        `order_items?date=${this.dateKey}`,
        {
          params: {
            date: this.dateKey
          }
        }
      );

      const orders = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const orderItem of result.order_items) {
        let order = orders.find(o => o.order.id === orderItem.order.id);
        if (!order) {
          order = { order: orderItem.order, orderItems: [] };
          orders.push(order);
        }
        order.orderItems.push(orderItem);
      }

      this.orders = orders;
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  display: inline-block;
  margin: 18px 0 10px;
  font-size: 12px;
  color: #555;
  text-decoration: underline;
}

.order {
  margin-bottom: 30px;
}

.order-title {
  text-align: center;
  font-size: 30px;
}
</style>
